import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getConfigurationByKey from 'store/app/selector/getConfigurationByKey';
import getLocaleSelector from 'store/app/selector/getLocaleSelector';
import { setStudioSearchCategoryAction } from '../slice';

const fetchStudioSearchCategoryDataOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const searchCategoryId = getConfigurationByKey('gettySearchResultCategoryId')(store);
    if (!searchCategoryId) {
      // eslint-disable-next-line no-console
      console.error('No categoryId for configuration key gettySearchResultCategoryId');
      return;
    }
    const locale = getLocaleSelector(store);
    try {
      const categoryData = (await apiRequest(
        endpoints.categoryPageV1Get,
        {
          locale,
          categoryId: searchCategoryId,
        },
        HttpMethods.GET,
        'data',
      )) as AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response;
      dispatch(setStudioSearchCategoryAction(categoryData));
    } catch (e: any) {
      // eslint-disable-next-line no-console
      console.error('Error fetching search category data');
    }
  };

export default fetchStudioSearchCategoryDataOperation;
